import React, { useRef, useState } from 'react'
import Webcam from 'react-webcam';
import { ReactComponent as RefeshIcon } from '../../assets/plus_icon/refresh.svg';
import { ReactComponent as CameraIcon } from '../../assets/plus_icon/capture.svg'
import axios from 'axios';
import { API_URLS } from '../../config/apiUrl';
import { Oval } from 'react-loader-spinner';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { toast } from 'react-toastify';

const CaptureImage = ({ setChannelPartner, image, setImage, handleSendOTP, isWithCP, setImgUrl, isLoading, setIsLoading, type, isCPVisit, previousStepBeforeCapture }) => {
    const [error, setError] = useState(false);
    const webcamRef = useRef(null);

    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
        },
        [webcamRef]
    );

    const handleSubmitImage = async () => {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

        if (image) {
            try {
                // Convert base64 image to Blob
                setIsLoading(true)
                const blobData = await fetch(image).then(res => res.blob());

                // Request a signed URL from the backend
                const response = await axios.post(`${API_URLS.baseurl}/public/getS3PresignedUrl`, {
                    key: `img_${new Date().getTime()}.jpg`,
                    contentType: blobData.type,
                });
                const signedUrl = response.data.data.url;

                // Upload the image to S3 using the signed URL
                await axios.put(signedUrl, blobData, {
                    headers: {
                        'Content-Type': blobData.type,
                    },
                }).then(res => {
                    setImgUrl(signedUrl.split('?')[0])
                    handleSendOTP()
                });

            } catch (error) {
                console.error('Error uploading the file:', error);
                if (isLocalhost) {
                    setImgUrl('https://via.placeholder.com/600x400.png?text=Localhost+Sample+Image');
                    handleSendOTP();
                }
            } finally {
                setIsLoading(false);
            }
        } else {
            if (isLocalhost) {
                setImgUrl('https://via.placeholder.com/600x400.png?text=Localhost+Sample+Image');
            }
            handleSendOTP()
        }
    }

    return (
        <div className='w-full'>
            <div className='!py-4 sm:!py-12 flex items-center justify-center w-full relative bg-white rounded-lg '>
                <button className='flex items-center absolute !left-4 md:left-12' onClick={() => {
                    if (!isCPVisit) {
                        if (isWithCP) {
                            setChannelPartner('4')
                        } else {
                            setChannelPartner('3')
                        }
                    } else {
                        setChannelPartner(previousStepBeforeCapture === '8' ? '8' : '4')
                    }
                }}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button>
                <p className='text-lg sm:text-3xl font-semibold mb-0 '>
                    Upload Image
                </p>

            </div>
            <div className='bg-white w-full rounded-lg flex flex-col items-center justify-center !mt-4 sm:!mt-8 !pb-4 space-y-6 xl:space-y-0 xl:!py-0'>
                {!image && <div className='w-full h-[58vh] relative !p-4 sm:!p-20 sm:hidden img-capture'>
                    <Webcam
                        audio={false}
                        // height={'60vh'}
                        // width={'100%'}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg" >
                        {({ getScreenshot }) => (
                            <button
                                className='w-full flex items-center justify-center'
                                onClick={() => {
                                    const imageSrc = getScreenshot();
                                    setImage(imageSrc)
                                }}
                            >
                                <span className=' w-full flex flex-col items-center justify-center  text-center  absolute bottom-[8%]'>
                                    <span className='w-[50px] h-[50px] border-2 rounded-full border-white flex items-center justify-center !p-1'>
                                        <span className='h-[40px] w-[40px] rounded-full '>
                                            <CameraIcon className='!h-[40px] !w-[40px]' />
                                        </span>
                                    </span>
                                    <p className='mb-0 uppercase text-white !mt-2 font-bold text-sm sm:text-lg'> CAPTURE</p>
                                </span>
                            </button>
                        )}
                    </Webcam>
                </div>}
                {/* {error && !image && (
                    <div className="text-red sm:!text-sm text-xs !mt-4">Please Capture Photo</div>
                )} */}
                {!image && <div className='w-full sm:h-[50vh] xl:h-[55vh] xl:w-[53%] hidden relative sm:block img-capture xl:!p-0'>
                    <Webcam
                        audio={false}
                        // height={'40%'}
                        // width={'100%'}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg" >
                        {({ getScreenshot }) => (
                            <button
                                className='w-full flex items-center justify-center '
                                onClick={() => {
                                    const imageSrc = getScreenshot()
                                    // console.log(imageSrc);
                                    setImage(imageSrc)
                                }}
                            >
                                <span className=' w-full flex flex-col items-center justify-center rounded-full text-center border-white !p-1 absolute bottom-[8%]'>
                                    <span className='w-[80px] h-[80px] border-2 rounded-full border-white flex items-center justify-center !p-1'>
                                        <span className=' h-[60px] w-[60px] rounded-full'>
                                            <CameraIcon className=' !h-[60px] !w-[60px]' />
                                        </span>
                                    </span>
                                    <p className='mb-0 uppercase text-white !mt-2 font-bold text-base sm:text-xl '> CAPTURE</p>
                                </span>

                            </button>
                        )}
                    </Webcam>
                    {/* {error && !image && (
                        <div className="text-red sm:!text-sm text-xs !mt-4">Please Capture Photo</div>
                    )} */}
                </div>}
                {
                    image && <div className='relative !p-4 sm:h-[50vh] xl:h-[55vh] xl:w-[60%] w-full capture-img flex items-center justify-center'>
                        <img src={image} alt="" />
                        <div className='absolute bottom-5 w-full flex flex-col items-center justify-center' onClick={() => setImage('')}>
                            <div className=' bg-white sm:h-[80px] sm:w-[80px] h-[40px] w-[40px] rounded-full flex items-center justify-center'>
                                <RefeshIcon className='' />
                            </div>
                            <p className='mb-0 uppercase text-white !mt-2 font-bold text-base sm:text-xl '> Retake</p>
                        </div>
                    </div>
                }
                <div className='w-full sm:space-x-4 sm:px-6 flex items-center flex-col-reverse sm:flex-row space-y-4 space-y-reverse sm:space-y-0' >
                    <button className='w-[95%] sm:w-1/2 text-lg sm:!text-xl border rounded-xl  !py-2 sm:!py-3.5' onClick={() => {
                        if (!isCPVisit) {
                            if (isWithCP) {
                                setChannelPartner('4')
                            } else {
                                setChannelPartner('3')
                            }
                        } else {
                            setChannelPartner(previousStepBeforeCapture === '8' ? '8' : '4')
                        }
                    }}>Back</button>
                    <button
                        className='w-[95%] sm:w-1/2 text-lg sm:!text-xl rounded-xl !py-2 flex items-center justify-center  sm:!py-3.5 bg-blue-900 text-white'
                        disabled={isLoading}
                        onClick={() => {
                            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                            if (!isLocalhost && (isCPVisit || type === 'master') && !image) {
                                toast.error("Please capture and upload photo")
                                return
                            } else if ((!isCPVisit && type === 'master') && image) {
                                setChannelPartner('6')
                            } else {
                                handleSubmitImage()
                            }
                        }}>
                        {!isLoading && ((image || type === 'master' || isCPVisit) ? 'Next' : 'Skip')}
                        {isLoading &&
                            <Oval

                                height={24}
                                width={30}
                                color="#FFFFFF"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#FFFFFF"
                                strokeWidth={8}
                                strokeWidthSecondary={8}
                            />
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CaptureImage